import React from "react";

function MainWrapper({ position, children }) {
  return (
    <main className={`w-full min-h-[600px] flex items-center justify-center`}>
      {children}
    </main>
  );
}

export default MainWrapper;
